import { render, staticRenderFns } from "./vipCenter.vue?vue&type=template&id=e2f861c6&scoped=true"
import script from "./vipCenter.vue?vue&type=script&lang=js"
export * from "./vipCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f861c6",
  null
  
)

export default component.exports